export const REWARDS = 'REWARDS';
export const CONDITIONAL_PROMOCODE = 'Conditional promo code';
export const NON_CONDITIONAL_PROMOCODE = 'Non-conditional promo code';
